import {
  useLoadScheduledReminderCount,
  useLoadSetting,
  useUpdateSetting,
} from "@smart/manage-gql-client-dom";

import { MessageContainer } from "./message-container";
import { useCustomReminderMessageFormCount } from "./use-custom-reminder-message-form-count";

const ClientMessages = () => {
  const setting = useLoadSetting({});
  const [update] = useUpdateSetting();
  const loadScheduledReminderCount = useLoadScheduledReminderCount();
  const customReminderMessageFormCount = useCustomReminderMessageFormCount();

  return (
    <MessageContainer
      setting={setting.result?.defaultClientMessage || {}}
      reminderSchedule={setting.result?.reminder}
      update={async (defaultClientMessage) => {
        await update({
          variables: {
            fields: {
              defaultClientMessage,
            },
          },
        });
      }}
      updateReminderSchedule={async (reminder) => {
        await update({
          variables: {
            fields: {
              reminder,
            },
          },
        });
      }}
      loadScheduledReminderCount={loadScheduledReminderCount}
      customReminderMessageFormCount={customReminderMessageFormCount}
      loading={setting.loading}
    />
  );
};

export { ClientMessages };
